import { setTag } from '@sentry/react';
import {
    UNSUPPORTED,
    getPlatformInfoClientHints,
    isUserAgentClientHintsSupported,
} from '@lingoda/user-agent';

export const setUserAgentClientHintsTags = async () => {
    if (!isUserAgentClientHintsSupported()) {
        setTag(USER_AGENT_CLIENT_HINTS_TAG_NAME, UNSUPPORTED);

        return;
    }

    const platformInfoClientHints = await getPlatformInfoClientHints();
    Object.entries(platformInfoClientHints)
        .filter(([, value]) => !!value)
        .forEach(([key, value]) => {
            setTag(`${USER_AGENT_CLIENT_HINTS_TAG_NAME}.${key}`, `${value}`);
        });
};

const USER_AGENT_CLIENT_HINTS_TAG_NAME = 'clientHintsApi';
